import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const LoadPicturesEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => {
  const waitForCompletion = payload?.waitForCompletion !== false;

  return (
    <Box>
      <TextField
        fullWidth
        value={payload?.outputPath || 'pictures'}
        onChange={(e) => onChange({ ...payload, outputPath: e.target.value })}
        label="Output Path"
        placeholder="pictures"
        helperText="Context path where picture data will be stored"
        margin="normal"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={waitForCompletion}
            onChange={(e) => onChange({ ...payload, waitForCompletion: e.target.checked })}
          />
        }
        label="Wait for loading to complete"
        sx={{ mt: 1, mb: 2 }}
      />

      {!waitForCompletion && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> Loading will continue in background. Ensure subsequent steps
            include a delay or use &ldquo;Wait for Context&rdquo; method to avoid accessing
            incomplete data.
          </Typography>
        </Alert>
      )}

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Output:</strong> Array of picture objects with id, resource, and categories
          <br />
          <strong>Source:</strong> Fetches all pictures from the API and transforms for UI use
          <br />
          <strong>Categories:</strong> Normalized to arrays for consistent access patterns
          <br />
          <strong>Wait Option:</strong> When unchecked, continues flow immediately while loading in
          background
        </Typography>
      </Alert>
    </Box>
  );
};
